import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer'; 
const SiteMap = () => {  
  useEffect(() => {
    document.title = 'Site Map - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Contact Us</li>
                    <li>Site Map</li>
                </ul>
            </div> 
            <section className="innerbody sitemap">
            <div className="container"> 
            <div className="row">
            <div className="col-sm-6 col-lg-3">
                <h3>School</h3>
                <ul className="sub-menu">
                    <li><Link to="/AboutUs">About School</Link></li>
                    <li><Link to="/SchoolInformation">School Information</Link></li>
                    <li><Link to="/Aims">Aims And Objectives</Link></li>
                    <li><Link to="/OurPhilosophy">Our Philosophy </Link></li>
                    <li><Link to="/CampusInformation">Campus Information</Link></li>
                    <li><Link to="/GeneralInformation">General Information</Link></li>
                    <li><Link to="/SchoolStrength">School Strength</Link></li>
                    <li><Link to="/Infrastructure">Infrastructure</Link></li>
                    <li><Link to="/OurPrinciples">Our Principles</Link></li>
                </ul>
            </div>
            <div className="col-sm-6 col-lg-3">
                <h3>Prospectus</h3>
                <ul className="sub-menu">
                    <li><Link to="/FeeStructure"> Fee Structure</Link></li>
                    <li><Link to="/JuniorWing">Junior Wing</Link></li>
                    <li><Link to="/SeniorWing"> Senior Wing</Link></li>
                    <li><Link to="/SpecialFeatures">Special Features</Link></li>
                    <li><Link to="/Academics">Academics</Link></li>
                    <li><Link to="/AdmissionWithdrawals">Admission And Withdrawals</Link></li>
                    <li><Link to="/Discipline">Discipline</Link></li>
                    <li><Link to="/EvaluationScholarships">Evaluation And Scholarships</Link></li>
                </ul>
            </div>
            <div className="col-sm-6 col-lg-3">
                <h3>Gallery</h3>
                <ul className="sub-menu">
                    <li><Link to="/Gallery">Photo Gallery</Link></li>
                    <li><Link to="/VideoGallery">Video Gallery</Link></li>
                    <li><Link to="/MediaGallery">Media Gallery</Link></li>
                    <li><Link to="/VirtualTour">Virtual Tour </Link></li>
                    <li><Link to="/VoiceSMS">Voice SMS </Link></li>
                </ul>
            </div>
            <div className="col-sm-6 col-lg-3">
                <h3>Messages</h3>
                <ul className="sub-menu">
                    <li><Link to="/ManagerMessage">Manager's Message</Link></li>
                    <li><Link to="/PrincipalMessage"> Principal's Message</Link></li>
                    <li><Link to="/HeadGirlMessage">Head Girl's Message</Link></li>
                    <li><Link to="/HeadBoyMessage">Head Boy's Message</Link></li>
                </ul>
            </div>
        </div>

        <div className="row">
            <div className="col-sm-6 col-lg-3">
                <h3>Achievements</h3>
                <ul className="sub-menu">
                    <li><Link to="/OurAchievements">Our Achievements</Link></li>
                    <li><Link to="/TopperX">TOPPERS X </Link></li>
                    <li><Link to="/TopperXII">TOPPERS XII </Link></li>
                </ul>
            </div>
            <div className="col-sm-6 col-lg-3">
                <h3>Office Bearers</h3>
                <ul className="sub-menu">
                    <li><Link to="/ManagingCommittee">Managing Committee</Link></li>
                    <li><Link to="/SchoolCabinet">School Cabinet</Link></li>
                    <li><Link to="/StaffList"> Staff List</Link></li>
                </ul>
            </div>
            <div className="col-sm-6 col-lg-3">
                <h3>Contact Us </h3>
                <ul className="sub-menu">
                    <li><Link to="/MailUs">Mail Us</Link></li>
                    <li><Link to="/GuestBook">Guest Book</Link></li>
                    <li><Link to="/SiteMap">Site Map </Link></li>
                </ul>
            </div>
        </div>
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default SiteMap;
